import React, { useContext, useEffect, useState } from "react";
import { Navbar, Nav, Container, Offcanvas, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../Assets/Images/Xprtme _Main_Logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import BlueButton from "../Components/BlueButton";
import SelectTag from "../Components/SelectTag";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { MdSpaceDashboard } from "react-icons/md";
import "./Navebar.css";
import FormButton from "../Components/FormButton";
import { useFormik } from "formik";
import { GetCoursesListById } from "../Redux/Actions/CoursesActions";
import { GlobalData } from "../App";
import LanguageDropdown from "../Components/LanguageDropdown";

const NavbarComponent = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const { SetFilterData } = useContext(GlobalData);
  const { i18n, t } = useTranslation();
  const Navigate = useNavigate();
  const Dispatch = useDispatch();
  const { UserData, IsLoggedin } = useSelector((state) => state.User);
  const { LookUpData } = useSelector((state) => state.LookUpGetAll);
  const lookupDetailsArray = LookUpData?.[1]?.LookupDetails || [];
  const roleId = UserData?.data?.roleId;

  const categoryOptions =
    lookupDetailsArray && lookupDetailsArray.length > 0
      ? lookupDetailsArray.map((detail) => ({
          value: detail?.Id,
          label: detail?.Name,
        }))
      : "";

  const handleSignUpbtn = () => {
    Navigate("/signup");
  };

  const handleLoginbtn = () => {
    Navigate("/login");
  };
  const handleDashboardbtn = () => {
    if (roleId === 2) {
      Navigate("/dashboard");
    } else {
      Navigate("/stdashboard");
    }
  };

  const handleLogo = () => {
    Navigate("/");
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setShowDropdown(false);
  };
  const initialValues = {
    courseCategoryID: "",
  };
  const { handleChange, values } = useFormik({
    initialValues: initialValues,
    onSubmit: (values, action) => {},
  });

  useEffect(() => {
    if (values?.courseCategoryID) {
      Dispatch(GetCoursesListById(values?.courseCategoryID, Navigate));
      SetFilterData(true);
    }
  }, [Dispatch, values.courseCategoryID, Navigate, SetFilterData]);

  return (
    <>
      <Navbar style={{ background: "#F5F5F5" }} className="Navebar" expand="lg">
        <Container fluid>
          <Navbar.Brand onClick={handleLogo}>
            <img
              src={logo}
              height="60px"
              className="d-inline-block align-top"
              alt="Logo"
              style={{ mixBlendMode: "multiply", cursor: "pointer" }}
            />
          </Navbar.Brand>
          <div className="d-flex align-items-center ">
            <div className="position-relative d-lg-none d-block ">
              <LanguageDropdown />
            </div>
            <Navbar.Toggle aria-controls="offcanvasNavbar" />
          </div>
          <Navbar.Offcanvas
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel">
                <img
                  src={logo}
                  height="60px"
                  className="d-inline-block align-top"
                  alt="Logo"
                  style={{ mixBlendMode: "multiply", cursor: "pointer" }}
                />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="d-flex justify-content-center flex-grow-1 gap-4 align-items-center ">
                <div className="d-flex gap-4 justify-content-center flex-grow-1 flex-column flex-lg-row align-items-center">
                  <NavLink to="/">{t("nav_home")}</NavLink>
                  <SelectTag
                    options={categoryOptions}
                    name="courseCategoryID"
                    label={t("categories")}
                    onChange={handleChange}
                    value={values.category}
                  />
                  <NavLink to="/about">{t("nav_about")}</NavLink>
                  <NavLink to="/contact">{t("nav_contact")}</NavLink>
                </div>

                {IsLoggedin === true ? (
                  <>
                    <div className="position-relative d-none d-lg-block">
                      <LanguageDropdown />
                    </div>
                    <FormButton
                      onClick={handleDashboardbtn}
                      ButtonIcon={
                        <MdSpaceDashboard
                          color="#fff"
                          cursor="pointer"
                          fontSize={20}
                        />
                      }
                      Buttontext={t("Dashboard")}
                      className="Login-btn"
                    />
                  </>
                ) : (
                  <>
                    <div className="position-relative d-none d-lg-block">
                      <LanguageDropdown />
                    </div>
                    <div className="me-5 d-flex ">
                      <Button id="Signup-btn" onClick={handleSignUpbtn}>
                        {t("signup")}
                      </Button>
                      <BlueButton
                        Buttontext={t("login")}
                        className="Login-btn"
                        onClick={handleLoginbtn}
                      />
                    </div>
                  </>
                )}
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </>
  );
};

export default NavbarComponent;
